import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, // Inclui cookies nas requisições, necessário para autenticação baseada em cookies
});

// Interceptor de requisição para adicionar o token e ajustar o Content-Type se necessário
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken');

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  // Se formData estiver presente no corpo da requisição, altera o Content-Type para multipart/form-data
  if (config.data instanceof FormData) {
    config.headers['Content-Type'] = 'multipart/form-data';
  }

  return config;
}, (error) => {
  return Promise.reject(error);
});

export default api;
